"use client";

import React from "react";
import Image from "next/image";
import { X } from "lucide-react";

import { Button } from "./ui/button";
import { Paragraph } from "./ui/typography";

import MobileQRVector from "@/resources/vector/mobile-qr.svg";

import { cn } from "@/lib/utils";

function DownloadAppPopup() {
  const [isVisible, setIsVisible] = React.useState(true);

  React.useEffect(() => {
    if (!window.localStorage.getItem("hide-mobile-app-modal")) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) return null;

  const handleOnClose = () => {
    setIsVisible(false);
    window.localStorage.setItem("hide-mobile-app-modal", true);
  };

  return (
    <div
      className={cn(
        "hidden fixed bottom-6 left-6 md:flex justify-center items-end rounded-xl h-49 w-32",
        "bg-primary-foreground z-50 shadow-elevation-6"
      )}
    >
      <Button
        variant="icon"
        onClick={handleOnClose}
        className="absolute top-0 right-0 p-0 bg-grayscale-body text-primary-foreground size-7 rounded-full -translate-y-1/2 translate-x-1/2"
      >
        <X />
      </Button>

      <Image
        src="/images/mobile-banner-bg.gif"
        alt="Mobile Banner BG"
        className="absolute top-0 left-0 rounded-xl opacity-60 -z-1 h-43.25"
        width={128}
        height={173}
      />

      <MobileQRVector className="block" />

      <div className="absolute bottom-0 left-0 py-2 px-1.25 bg-grayscale-body rounded-b-xl">
        <Paragraph
          variant="b5-tight"
          className="text-primary-foreground text-center"
        >
          For better experience download our app
        </Paragraph>
      </div>
    </div>
  );
}

export default DownloadAppPopup;
